import { useState } from 'react'
import { Form, LinkBase, required, useLocation, useNavigate, useNotify } from 'ra-core'
import type { SubmitHandler, FieldValues } from 'react-hook-form'
import { Button } from '@internal/ui-kit/components/ui/button'
import { TextInput } from '@internal/ui-kit/components/admin/text-input'
import { AuthPageLayout } from './AuthPageLayout'
import { resetPassword } from '@/providers/authProvider'
import { extractErrorMessage } from '@internal/ui-kit/lib/httpClient'

export const ResetPasswordPage = () => {
  const [loading, setLoading] = useState(false)
  const location = useLocation()
  const navigate = useNavigate()
  const notify = useNotify()
  const token = new URLSearchParams(location.search).get('token') ?? ''

  const handleSubmit: SubmitHandler<FieldValues> = async (values) => {
    setLoading(true)
    try {
      await resetPassword(values.password, token)
      notify('Your password has been reset. Please sign in.', { type: 'success' })
      navigate('/login')
    } catch (error) {
      notify(extractErrorMessage(error, 'Could not reset your password.'), { type: 'error' })
    } finally {
      setLoading(false)
    }
  }

  if (!token) {
    return (
      <AuthPageLayout
        title="Reset your password"
        footer={
          <p className="text-sm text-muted-foreground text-center">
            <LinkBase to="/request-password-reset">Request a new reset link</LinkBase>
          </p>
        }
      >
        <p className="text-sm">This reset link is missing or invalid.</p>
      </AuthPageLayout>
    )
  }

  return (
    <AuthPageLayout title="Reset your password">
      <Form className="space-y-4" onSubmit={handleSubmit}>
        <TextInput label="New password" source="password" type="password" validate={required()} />
        <Button type="submit" className="w-full cursor-pointer" disabled={loading}>
          Reset password
        </Button>
      </Form>
    </AuthPageLayout>
  )
}
